import { WorkType as ApiWorkType } from '@smile-next/api/lib/drill';
export var WorkTypeList = ApiWorkType;
